import React from "react";
import { Container } from "react-bootstrap";
import { Skeleton } from "antd";

import FoundersListView from "./FoundersListView.jsx";
import FounderDetail from "./FounderDetail.jsx";

function Founders({ banners }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Simulate loading state using a boolean flag
  const isLoading = false; // Replace this with your actual loading logic

  if (isLoading) {
    return (
      <>
        {/* Display a skeleton while loading */}
        <Skeleton active />
      </>
    );
  }

  return (
    <>
      <FounderDetail id={1} banners={banners} />
      <Container>
        <FoundersListView />
      </Container>
    </>
  );
}

export default Founders;
